export const WARNING_CONSTANTS = {
  MAIN_LANGUAGE_EXPORTED_FOR_REVIEW:
    'Main language data has been exported for review. Modifications may get lost with the next import. Problems may also occur if changes are not propagated to the siblings.',
  TRANSLATION_PENDING: 'Changes may be lost because a translation by the technical writing team was requested.',
  ALREADY_TRANSLATED: 'This entry has already been translated by the technical writing team.',
};
